import { code } from 'currency-codes'
import { TFunction } from 'i18next'
import { Currency } from 'src/api/currency'
import { z } from 'zod'
export const getDepositSplitSchema = (amount?: number, t?: TFunction, currency?: Currency, formatCurrency?: (integerAmount: number, currency: Currency) => string) => {
  return z
    .object({
      operation: z.enum(['edit', 'split']),
      amountToSplit: z.number().optional(),
      reference: z
        .object({
          type: z.enum(['bill', 'reservation', 'reservedResource']),
          description: z.string(),
          billId: z.string().optional(),
          reservationId: z.string().optional(),
          reservedResourceId: z.string().optional(),
        })
        .superRefine((data, context) => {
          if (data.type === 'bill' && !data.billId)
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['reference.type'],
              message: t ? t('pms.common.deposit_document.spit_validation_bill') : 'bill is required',
            })
          else if (data.type === 'reservation' && !data.reservationId)
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['reference.type'],
              message: t ? t('pms.common.deposit_document.spit_validation_reservation') : 'bill is required',
            })
        }),
    })
    .superRefine((data, context) => {
      if (data.operation === 'split' && !data.amountToSplit) {
        context.addIssue({
          path: ['amountToSplit'],
          code: z.ZodIssueCode.custom,
          message: t ? t('commons.required_field') : 'Required field',
        })
      }
      if (data.operation === 'split' && data.amountToSplit && amount && (data.amountToSplit < 1 || data.amountToSplit > amount)) {
        context.addIssue({
          path: ['amountToSplit'],
          code: z.ZodIssueCode.custom,
          message: t
            ? t('commons.validation.number.between', { min: (currency && formatCurrency?.(1, currency)) ?? 1, max: (currency && formatCurrency?.(amount, currency)) ?? amount })
            : 'Required field',
        })
      }
    })
}
